export const InputStatuses = ['warning', 'error', ''] as const;

export const ValidateStatuses = ['success', 'warning', 'error', 'validating', ''] as const;

export const progressStatuses = ['normal', 'exception', 'active', 'success'] as const;
